function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "UID",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Customers-Transactions3-1-(Filters-Tick1)",
  transform: "translate(-1233.000000, -331.000000)",
  fill: "currentColor"
}, React.createElement("g", {
  id: "Filters",
  transform: "translate(250.000000, 220.000000)"
}, React.createElement("g", {
  id: "btns",
  transform: "translate(969.000000, 98.000000)"
}, React.createElement("g", {
  id: "btn-filter"
}, React.createElement("g", {
  id: "filter",
  transform: "translate(14.000000, 13.000000)"
}, React.createElement("path", {
  d: "M12.6861865,0 L1.31405764,0 C0.148174826,0 -0.440071268,1.41451953 0.38598342,2.24057422 L4.81249904,6.66864844 L4.81249904,11.375 C4.81249904,11.7881094 5.00699514,12.1771289 5.33749904,12.46875 L7.08749904,13.7557109 C7.94262014,14.3533086 9.18749904,13.7977656 9.18749904,12.7057109 L9.18749904,6.66864844 L13.6142608,2.24057422 C14.4386475,1.4161875 13.8543936,0 12.6861865,0 Z M7.87499904,6.125 L7.87499904,12.6875 L6.12499904,11.375 L6.12499904,6.125 L1.31249904,1.3125 L12.687499,1.3125 L7.87499904,6.125 Z",
  id: "Shape"
})))))));

var SvgIcFilter = function SvgIcFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    fill: "currentColor",
    stroke: "currentColor",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-filter.b55d92f2.svg";
export { ForwardRef as ReactComponent };